import { Grid } from '@mui/material';
import React from 'react';

interface StepContainerProps {
  children: React.ReactNode;
  dataTestId?: string;
}

const StepperContentContainer: React.FC<StepContainerProps> = ({ children, dataTestId }) => {
  return (
    <Grid
      size={12}
      container
      rowSpacing={3}
      columnSpacing={2}
      paddingX={1}
      paddingTop={4}
      justifyContent="flex-start"
      alignItems="flex-start"
      alignContent="flex-start"
      height={`calc(100vh - 195px)`}
      data-testid={dataTestId}
      sx={{ overflowY: 'scroll' }}
    >
      {children}
    </Grid>
  );
};

export default StepperContentContainer;
